import * as React from 'react';
import { Grid } from '@material-ui/core';
import { defaultTranslateFn } from "../../../../common";
import { Select } from "../../../select";
import { StyledInformationIcon } from '../../common';
import { VehicleAttributeTooltipEnumKey, VehicleAttributeLabelEnumKey, VehicleAttributeDefaultOptionEnumKey, VehicleAttributeValueLabelEnumKey } from '../enums';
import { StyledAttribute, StyledTooltip } from '../styles';
/**
 * Common reusable component for Vehicle Attribute
 * @param id [Required] Vehicle Attribute ID
 * @param attributeType [Required] - Pin or Nada or Redbook
 * @param selectedAttributeValue [Required] - Selected Vehicle Attribute Value (i.e. PinVid or NadaVid or ControlNumber)
 * @param attributes [Required] - Array of VehicleAttributes (i.e. PinAttributes or NadaAttributes or RedbookAttributes)
 * @param onAttributeChange [Required] - Callback method for Select input
 * @param translateFn [Optional] - Method used for translations
 */
export const VehicleAttribute = ({ id, attributeType, selectedAttributeValue, attributes, onAttributeChange, translateFn = defaultTranslateFn }) => {
    /* This function run onChange of select input */
    const onChange = (selectedOption) => onAttributeChange(VehicleAttributeValueLabelEnumKey.get(attributeType), selectedOption.value);
    /* creating attribute options */
    const getSelectOptions = () => {
        const attributeOptions = [];
        const valueKey = VehicleAttributeValueLabelEnumKey.get(attributeType);
        attributes.forEach((attribute) => {
            attributeOptions.push({
                label: attribute.fullDescription,
                value: attribute[valueKey]
            });
        });
        return attributeOptions;
    };
    /* find selected attribute option */
    const getSelectedValue = () => {
        const selectOptions = getSelectOptions();
        return selectOptions.find(option => option.value === selectedAttributeValue);
    };
    /* making ID for vehicle attribute selector input */
    const selectorId = `${id}Selector`;
    const selectorLabelId = `${attributeType}Description`;
    /* show description of first item when attributes length is 1 or Select input when attributes length is greater than 1 */
    const renderAttributeLabelValue = (attributes.length === 1 && (React.createElement("span", { id: selectorLabelId, "data-testid": "attribute-description" }, translateFn(attributes[0].fullDescription)))) || (React.createElement(Select, { id: selectorId, required: true, onChange: onChange, options: getSelectOptions(), value: getSelectedValue(), placeholder: translateFn(VehicleAttributeDefaultOptionEnumKey.get(attributeType)) }));
    return (React.createElement(StyledAttribute, { container: true, item: true, xs: 12 },
        React.createElement(Grid, { container: true, item: true, xs: 12 },
            React.createElement("label", { id: `${attributeType}Label` }, translateFn(VehicleAttributeLabelEnumKey.get(attributeType))),
            React.createElement(StyledTooltip, { title: translateFn(VehicleAttributeTooltipEnumKey.get(attributeType)), placement: "top", arrow: true },
                React.createElement(StyledInformationIcon, { className: "mi-icon-information-filled-circle", "data-testid": "mi-icon-information-filled-circle" }))),
        React.createElement(Grid, { container: true, item: true, xs: 12 }, renderAttributeLabelValue)));
};
//# sourceMappingURL=VehicleAttribute.js.map